import { Stack, Typography, Theme } from "@mui/material";
import { TFunction } from "i18next";
import Panel from "@/features/Common/components/Panel";
import { convertPxToRem, formatAmount } from "@/utils";

export enum DashboardServiceOfferingTypes {
  DOCTOR_AND_NURSE_CONSULT = "DOCTOR_AND_NURSE_CONSULT",
  BLOOD_TESTS = "BLOOD_TESTS",
  HEALTH_CHECK = "HEALTH_CHECK",
  BUY_VOUCHER = "BUY_VOUCHER",
  DOC_MED_BUNDLE = "DOC_MED_BUNDLE",
}

export default function FeaturedServiceOfferingPriceCTA(
  type: DashboardServiceOfferingTypes,
  amount: number,
  currencyCode: string,
  discountApplied: boolean,
  originalAmount: number,
  t: TFunction
) {
  if (type === DashboardServiceOfferingTypes.DOC_MED_BUNDLE) {
    const isDiscountApplied = Boolean(discountApplied) || false;
    const amountFormatted = formatAmount(amount || 0, currencyCode || "");
    const originalAmountFormatted = formatAmount(
      originalAmount || 0,
      currencyCode || ""
    );
    return (
      <Panel
        sx={{
          ...(isDiscountApplied === true && {
            paddingRight: convertPxToRem(30),
            paddingTop: convertPxToRem(5),
            paddingBottom: convertPxToRem(5),
          }),
          boxShadow: "none",
          backgroundColor: (theme: Theme) =>
            isDiscountApplied
              ? theme.palette.accent4.main
              : theme.palette.primary.main,
        }}
      >
        <>
          {!isDiscountApplied ? (
            <Typography fontWeight={600} color="info">
              {t("PayGMemberDashboard.FeaturedServiceOffering.panel.price", {
                priceFormatted: amountFormatted,
              })}
            </Typography>
          ) : (
            <Stack color="info" textAlign="left">
              <Typography fontWeight={600} color="info">
                {t(
                  "PayGMemberDashboard.FeaturedServiceOffering.panel.originalAmount.price",
                  {
                    priceFormatted: amountFormatted,
                  }
                )}
              </Typography>
              <Typography
                fontWeight={600}
                color="info"
                variant="body2"
                sx={{ textDecoration: "line-through" }}
              >
                {t(
                  "PayGMemberDashboard.FeaturedServiceOffering.panel.discount.price",
                  {
                    priceFormatted: originalAmountFormatted,
                  }
                )}
              </Typography>
            </Stack>
          )}
        </>
      </Panel>
    );
  }
}
